import React, { useState, useEffect } from "react";
import { Grid, Button, Header } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { userData } from "../store/userData";
import Swal from "sweetalert2";
const ToursList = () => {
  const navigate = useNavigate();
  const userDetail = userData();
  const [excelData, setexcelData] = useState([]);
  const [rowData, setrowData] = useState([]);
  useEffect(() => {
    getVechileList();
    getTourList();
    getEmployeeList();
  }, []);

  const getTourList = async () => {
    await axios
      .post(BaseUrlInvoice + "accounts/listTour", { ssTourId: 1 })
      .then((res) => {
        console.log(res.data);
        setrowData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [driverList, setdriverList] = useState([]);
  const [carList, setcarList] = useState([]);

  const getEmployeeList = async () => {
    await axios
      .get(BaseUrl + "getBackOfficeUserList")
      .then((res) => {
        console.log(res.data);
        const tempData = res.data;
        const filterItem = tempData.filter((item) => item.userRole == 6);
        console.log("filterItem", filterItem);
        let tempArr = [];
        for (let i = 0; i < filterItem.length; i++) {
          tempArr.push({
            text: filterItem[i].userFirstName + filterItem[i].userLastName,
            value: filterItem[i].userId,
          });
        }
        setdriverList(tempArr);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getVechileList = async () => {
    await axios
      .post(BaseUrlInvoice + "accounts/listVehicle", { vehicleId: 1 })
      .then((res) => {
        console.log(res.data);

        const filterItem = res.data;
        let tempArr = [];
        for (let i = 0; i < filterItem.length; i++) {
          tempArr.push({
            text: filterItem[i].vehicleBrand + "-" + filterItem[i].model,
            value: filterItem[i].vehicleId,
          });
        }
        setcarList(tempArr);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const columnDefs = [
    {
      headerName: "Driver",
      field: "tourDriverId",
      valueGetter: (params) => {
        const driverId = params.data.tourDriverId;
        const driver = driverList.find((driver) => driver.value === driverId);
        return driver ? driver.text : ""; // Display the driver's name or an empty string if not found
      },
    },
    {
      headerName: "Vechile",
      field: "tourVehicleId",
      valueGetter: (params) => {
        const vehicleId = params.data.tourVehicleId;
        const vehicle = carList.find((driver) => driver.value === vehicleId);
        return vehicle ? vehicle.text : ""; // Display the driver's name or an empty string if not found
      },
    }, //customerName
    { headerName: "Name", field: "tourName" },
    { headerName: "Start Date", field: "startDate" },
    { headerName: "End Date", field: "endDate" },
    // { headerName: "Application Num", field: "applicationNumber" },

    { headerName: "Starting Kms", field: "startingKms" },
    // { headerName: "ID", field: "id" },
    { headerName: "Ending Kms ", field: "endingKms" },
    { headerName: "customer Name", field: "customerName" },
    { headerName: "Customer Number ", field: "customerNumber" },
    { headerName: "Pickup Location", field: "pickupLocation" },

    // { headerName: "Status", field: "status" },
    // { headerName: "Customer Name", field: "customerName" },

    {
      headerName: "Edit/Delete",
      filter: false,
      field: "ssVisaId",
      cellRendererFramework: (params) => (
        <div>
          <Button color="primary" onClick={() => updateRecord(params)}>
            <AiFillEdit />
          </Button>
          <Button color="red" onClick={() => deleteRecord(params)}>
            <AiFillDelete />
          </Button>
        </div>
      ),
    },
  ];

  const updateRecord = (params) => {
    navigate(`/create-new-tour/${params.data.ssTourId}`);
  };
  const deleteRecord = (params) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(BaseUrlInvoice + "accounts/deleteTour", {
            ssTourId: params.data.ssTourId,
          })
          .then((res) => {
            console.log("res", res.data);
            Swal.fire("Deleted!", "Tour Recored has been deleted.", "success");
            getTourList();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };
  const defaultColDef = {
    sortable: true,
    editable: true,
    // flex: 1,
    filter: true,
    floatingFilter: true,
  };

  return (
    <div>
      <Header dividing size="huge" as="h1">
      Tour List
      </Header>
      <Grid.Row>
        <Button
          color="primary"
          onClick={() => navigate(`/create-new-tour/null`)}
        >
          Create New
        </Button>
      </Grid.Row>
      <Grid.Row>
        <div className="ag-theme-alpine" style={{ height: 600 }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            pagination={true}
          ></AgGridReact>
        </div>
      </Grid.Row>
    </div>
  );
};

export default ToursList;
